<template>
  <div>
    <page-title heading="Antrean Pasien" :breadcrumb="[
        {
          label: 'rawat jalan',
          active: true,
          link: '/antrean'
        }
      ]" />
    <div class="container-fluid">
      <div class="card card-box mb-5">
        <div class="card-body">
          <b-modal ref="my-modal" title="Detail Registrasi Antrean">
            <b-row v-for="(data, index) in dataRegistrasiPasien" :key="index" class="mb-2 pl-3 pr-3">
              <b-col sm="6">
                <div class="d-flex">
                  <template v-if="data.label == 'TANDA TANDA VITAL' || data.label == 'DATA PASIEN'">
                    <strong>{{data.label}}</strong>
                  </template>
                  <template v-else>
                    <div class="flex-grow-1 text-capitalize">
                      {{ data.label }}
                    </div>
                    <span>:</span>
                  </template>
                </div>
              </b-col>
              <b-col sm="6">
                {{ data.value }}
              </b-col>
            </b-row>
            <template v-slot:modal-footer>
              <div class="w-100">
                <b-button variant="primary" class="float-right" @click="toggleModal">
                  Tutup
                </b-button>
              </div>
            </template>
          </b-modal>
          <b-row style="display: none !important;">
            <b-col sm="12">
              <b-button variant="danger" class="text-capitalize mb-3" @click="checkAlihkan"
                style="float:right!important;">Alihkan Antrean</b-button>
              <span style="float:right!important;">
                <font-awesome-icon icon="info-circle" size="lg" class="mt-2 mr-2"
                  v-tooltip="'Klik disini untuk mengakhiri jadwal praktik dan mengalihkan sisa antrean Anda pada jadwal praktik selanjutnya'" />
              </span>
            </b-col>
          </b-row>
          <DataTableWrapper :perPage="perPage" :currentPage="currentPage" :callbackFunc="fetchListAntrean"
            @valueChanged="handleValueChanged">
            <template v-slot:right-header>
              <b-button :to="{ name: 'registrasi-rawat-jalan' }" variant="primary" class="text-capitalize ml-2">Tambah
                Antrean</b-button>
            </template>
            <b-table :items="pasiens" :fields="fieldList" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
              thead-tr-class="izd-datatable" :no-local-sorting="true">
              <template v-slot:head()="data">
                {{ data.label }}
                <b-input size="sm" class="mt-2 w-82" v-if="data.field.searchable"
                  @input="searchValueChanged($event, data.field.key)" />
              </template>
              <template v-slot:cell(nama)="data">
                <template v-if="data.item.extend == '1'">
                  <strong class="text-uppercase" style="color:blue;">{{ data.value }}</strong>
                  <b-button size="sm" pill variant="outline-primary" class="text-uppercase">Antrean Sebelumnya
                  </b-button>
                </template>
                <template v-else>
                  {{ data.value }}
                </template>
              </template>
              <template v-slot:cell(nomor_hp)="data">
                <template v-if="data.item.extend == '1'">
                  <strong class="text-uppercase" style="color:blue;">{{ data.value }}</strong>
                </template>
                <template v-else>
                  {{ data.value }}
                </template>
              </template>
              <template v-slot:cell(nomor_antrian)="data">
                <template v-if="data.item.extend == '1'">
                  <strong class="text-uppercase" style="color:blue;">{{ data.value }}</strong>
                </template>
                <template v-else>
                  {{ data.value }}
                </template>
              </template>
              <template v-slot:cell(waktu_konsultasi)="data">
                <template v-if="data.item.extend == '1'">
                  <strong class="text-uppercase" style="color:blue;">{{ data.value }}</strong>
                </template>
                <template v-else>
                  {{ data.value }}
                </template>
              </template>
              <template v-slot:cell(jenis_kelamin)="data">
                <template v-if="data.item.extend == '1'">
                  <strong class="text-uppercase" style="color:blue;">{{ jenisKelamin(data.value) }}</strong>
                </template>
                <template v-else>
                  {{ jenisKelamin(data.value) }}
                </template>
              </template>
              <template v-slot:cell(status)="data">
                <b-badge variant="warning" v-if="data.value.toLowerCase() === 'menunggu'"
                  style="background-color: #e6bf32">{{ data.value }}</b-badge>
                <b-badge variant="warning" v-else-if="data.value.toLowerCase() === 'selesai'"
                  style="background-color: #4e4e4b">{{ data.value }}</b-badge>
                <b-badge variant="primary" v-else>{{ data.value }}</b-badge>
              </template>
              <template v-slot:cell(actions)="data">
                <span>
                  <b-dropdown id="dropdown-1" class="text-capitalize" variant="primary" size="sm" right>
                    <template v-slot:button-content>
                      <font-awesome-icon icon="copy" />
                    </template>
                    <b-dropdown-item @click="
                          assignDataRegistrasiPasien(data);
                        ">Detail Registrasi Antrean</b-dropdown-item>
                    <template v-if="isDoctor">
                      <b-dropdown-item @click="
                            rekamMedis(data)
                          ">Tulis rekam medis</b-dropdown-item>
                    </template>
                    <template v-if="data.item.status !== 'KONSULTASI'">
                      <b-dropdown-item @click="
                          pembatalanAntrean({
                            id: data.item.id,
                            namaPasien: data.item.nama
                          })
                        ">hapus antrean</b-dropdown-item>
                    </template>
                  </b-dropdown>
                </span>
              </template>
            </b-table>
          </DataTableWrapper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
  import {
    mapGetters
  } from "vuex";
  import startCase from "lodash/startCase";
  import debounce from "lodash/debounce";
  import "element-ui/lib/theme-chalk/index.css";

  import {
    DateTime as LuxonDateTime
  } from "luxon";

  import {
    library
  } from "@fortawesome/fontawesome-svg-core";

  import moment from "moment";
  moment.locale('id');

  import lang from "element-ui/lib/locale/lang/en";
  import locale from "element-ui/lib/locale";
  import {
    faArrowRight,
    faArrowUp,
    faInfoCircle,
    faTrashAlt,
    faSearch,
    faPencilAlt,
    faCopy
  } from "@fortawesome/free-solid-svg-icons";
  library.add(faArrowRight, faInfoCircle, faArrowUp, faTrashAlt, faSearch, faPencilAlt, faCopy);
  locale.use(lang);

  const __dataRegistrasiPasien = {
    dp: {
      label: "DATA PASIEN",
    },
    nama: {
      label: "nama pasien",
      value: null
    },
    rekam_medis: {
      label: "no. rekam medis",
      value: null
    },
    hp: {
      label: "no. handphone",
      value: null
    },
    kelamin: {
      label: "jenis kelamin",
      value: null
    },
    dokter: {
      label: "dokter",
      value: null
    },
    keterangan_lain: {
      label: "keterangan lain",
      value: null
    },
    tanda: {
      label: "TANDA TANDA VITAL",
    },
    tb: {
      label: "tinggi badan ",
      value: null,
    },
    bb: {
      label: "berat badan ",
      value: null
    },
    suhu: {
      label: "suhu",
      value: null,
    },
    tensi_diastole: {
      label: "tekanan diastole",
      value: null
    },
    tensi_sistole: {
      label: "tekanan sistole",
      value: null
    },
    nadi: {
      label: "nadi",
      value: null,
    },
    anamnesis: {
      label: "anamnesis",
      value: null
    },
    alergi_kondisi_khusus: {
      label: "alergi & kondisi khusus",
      value: null
    }
  };

  export default {
    components: {
      DataTableWrapper: () => import("../../components/DataTableWrapper")
    },
    data: () => ({
      dataRegistrasiPasien: null,
      items: [],
      pasiens: [],
      noRekamMedis: "",
      namaPasien: "",
      waktuRegistrasi: "",
      tanggal: null,
      checkPaketData: null,
      searchValue: [],
      totalEntries: 0,
      statusAntrean: "Menunggu",
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      rows: 0,
      fromPage: 0,
      toPage: 0,
      perPage: 10,
      klinikAddress: null,
      minDatetime: LuxonDateTime.local().toISO(),
      maxDatetime: LuxonDateTime.local()
        .plus({
          years: 3
        })
        .toISO(),
      pickerOptions: {
        disabledDate: date => {
          const x = moment(date);
          const day = moment().subtract(1, "day");
          return x.isBefore(day);
        }
      },
      daterangeValue: Array(2).fill(new Date(), 0, 2)
    }),
    computed: {
      ...mapGetters({
        isDoctor: "doctorRole",
        getKlinikId: "getKlinikId"
      }),
      fieldList() {
        const {
          generateFieldList: g,
          setSearchableAndSortableFieldList: s
        } = this;
        const r = val => Boolean(/(waktu_konsultasi|status|actions|jenis_kelamin)\b/gi.test(val) ? !1 : 1);
        return (
          [{
              key: "waktu_konsultasi",
              label: "waktu registrasi",
              thStyle: "width: 13%"
            },
            {
              key: "nomor_antrian",
              label: "no. urut",
              thStyle: "width: 10%"
            },
            {
              key: "nama",
              label: "nama pasien"
            },
            {
              key: "nomor_hp",
              thStyle: "width: 16%"
            },
            {
              key: "jenis_kelamin",
              thStyle: "width: 14%"
            },
            {
              key: "actions"
            },
            {
              key: "status"
            }
          ] |> (v => s({
            field: v,
            customFunc: r
          })) |> (z => g({
            field: z
          }))
        );
      },
    },
    async mounted() {
      await this.cekPaket();
      moment.locale("id");
      this.tanggal = moment().format("YYYY-MM-DD");
      this.getProfile();
    },
    watch: {
      currentPage() {
        this.fetchListAntrean();
      },
      perPage() {
        this.fetchListAntrean();
      },
      sortBy() {
        this.fetchListAntrean();
      },
      sortDesc() {
        this.fetchListAntrean();
      },
      searchValue: {
        handler: "fetchListAntrean",
        deep: true
      }
    },
    methods: {
      async checkAlihkan() {
        try {
          const res = await this.$axios.get(`transaksi/queue/check`);
          const resSwitch = await this.$axios.get(`transaksi/switch/check`);
          const now = moment().format('HH');
          if (!res.data.status) {
            return this.$swal({
              text: `Anda tidak memiliki pasien untuk dialihkan!`,
              type: "warning",
              showCancelButton: false,
              confirmButtonText: "OK"
            });
          } else if (!resSwitch.data.status && now >= 0 && now <= 3) {
            return this.$swal({
              text: `Apakah Anda akan memasukan pasien baru pada jadwal praktik Anda selanjutnya?`,
              type: "warning",
              allowOutsideClick: false,
              showCancelButton: true,
              allowEscapeKey: false,
              cancelButtonText: startCase("TIDAK, LANJUTKAN DARI SEBELUMNYA"),
              confirmButtonText: startCase(`YA`)
            }).then(respon => {
              if (respon.value) {
                this.$axios.get(`transaksi/switch/add`);
                return this.fetchListAntrean();
              }
            });
          } else {
            return this.$swal({
              text: `Sisa Antrean Anda berjumlah ${res.data.data} orang akan dialihkan pada jadwal praktik Anda selanjutnya. Apakah Anda yakin?`,
              type: "warning",
              allowOutsideClick: false,
              showCancelButton: true,
              allowEscapeKey: false,
              cancelButtonText: startCase("batal"),
              confirmButtonText: startCase(`ya, alihkan`)
            }).then(respon => {
              if (respon.value) {
                this.$axios.get(`transaksi/queue/move`);
                return this.fetchListAntrean();
              }
            });
          }
        } catch (error) {
          return this.$swal({
            text: `Anda tidak memiliki pasien untuk dialihkan!`,
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "OK"
          });
        }
      },
      async getProfile() {
        try {
          var profile = this.$store.state.user.id
          const res = await this.$axios.get(`user/${profile}?klinik_id=${this.getKlinikId}`);
          this.klinikAddress = res.data.data.klinik.alamat;
        } catch (err) {
          // console.log(err);
        }
      },
      handleValueChanged({
        perPage,
        currentPage
      }) {
        perPage && (perPage |> (_ => (this.perPage = _)));
        currentPage && (currentPage |> (_ => (this.currentPage = _)));
      },
      searchValueChanged: debounce(function (val, key) {
        const {
          searchValue
        } = this;
        const z = searchValue.filter(item => item.key !== key);
        this.searchValue = [
          ...z,
          {
            key,
            value: val
          }
        ];
      }, 500),
      determineParameter() {
        const {
          searchValue,
          sortBy,
          sortDesc
        } = this;
        let v = "";
        searchValue.map(item => {
          const x =
            (item.key === "nama" && "nama_pasien") || item.key;
          v += `&${x}=${item.value}`;
        });

        if (sortBy) {
          v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
        }
        return v;
      },
      async fetchListAntrean() {
        try {
          const waktuRegistrasi =
            this.waktuRegistrasi && moment(this.waktuRegistrasi).format("YYYY-MM-DD");
          const res = await this.$axios.get(
            `transaksi?limit=${this.perPage}&page=${
            this.currentPage
          }${this.determineParameter()}`
          );
          const {
            success,
            data
          } = res.data;
          if (success) {
            const {
              trans_klinik: dataAntrean,
              total
            } = data;
            const {
              data: listAntrean,
              total: totalEntries,
              to: toPage,
              from: fromPage
            } = dataAntrean;
            this.totalEntries = totalEntries;
            this.toPage = toPage;
            this.fromPage = fromPage;
            this.pasiens = [
              ...listAntrean.map((item, index) => {
                return {
                  id: item.id,
                  waktu_konsultasi: item.waktu_konsultasi,
                  nomor_antrian: item.nomor_antrian,
                  status: item.status,
                  jenis_kelamin: item.jenis_kelamin,
                  nama: item.nama,
                  nomor_hp: item.nomor_hp,
                  pasien_id: item.pasien_id,
                  extend: item.extend,
                  no: (this.currentPage - 1) * this.perPage + index + 1
                };
              })
            ];
            this.rows = dataAntrean.total;
            return this;
          }
        } catch (err) {
          // console.log(err);
        }
      },
      changePage(page) {
        this.fetchAntrean(page);
      },
      async assignDataRegistrasiPasien({
        item: {
          rekam_medis = null,
          ktp = null,
          nama = null,
          hp = null,
          kelamin = null,
          dokter = null,
          waktu = null,
          pasien_id = null,
          id = null,
          anamnesis = null,
          tb = null,
          bb = null,
          suhu = null,
          nadi = null,
          tensi_diastole = null,
          tensi_sistole = null,
          alergi_kondisi_khusus = null,
          keterangan_lain = null,
        } = {}
      }) {
        try {
          const {
            toggleModal,
            getPasien
          } = this;
          const res = await getPasien(id);
          if (res) {
            const {
              id,
              dokter_id: dokter,
              pasien_id,
              nomor_antrian,
              klinik_id,
              anamnesa: anamnesis,
              waktu_konsultasi: waktu,
              pasien: {
                nomor_rekam_medis,
                nik: ktp,
                nama,
                nomor_hp: hp,
                jenis_kelamin: kelamin,
                tensi_sistole: tensi_sistole,
                tensi_diastole: tensi_diastole,
                nadi: nadi,
                suhu: suhu,
                tinggi_badan: tb,
                berat_badan: bb,
                alergi_kondisi_khusus: alergi_kondisi_khusus,
                keterangan_lain: keterangan_lain
              }
            } = res;
            const x = __dataRegistrasiPasien;
            x["nama"].value = nama;
            x["rekam_medis"].value = nomor_rekam_medis;
            x["hp"].value = hp;
            x["kelamin"].value = this.jenisKelamin(kelamin);
            x["dokter"].value = dokter.nama;

            x["tb"].value = tb.toString().replace('.', ',') + ' (cm)';
            x["bb"].value = bb.toString().replace('.', ',') + ' (kg)';

            x["suhu"].value = suhu + ' (celcius)';
            x["tensi_sistole"].value = tensi_sistole;
            x["tensi_diastole"].value = tensi_diastole;
            x["nadi"].value = nadi;
            x["anamnesis"].value = anamnesis;
            x["alergi_kondisi_khusus"].value = alergi_kondisi_khusus;
            x["keterangan_lain"].value = keterangan_lain;

            this.dataRegistrasiPasien = x;
            this.toggleModal();
          }
        } catch (err) {}
      },
      rekamMedis(data) {
        if (this.klinikAddress == null) {
          this.$swal({
              title: '',
              text: `Silakan Lengkapi Alamat Praktik Anda terlebih dahulu!`,
              type: 'warning',
              confirmButtonText: startCase('OK')
            })
            .then(_ => {
              this.$router.push('/profile')
            })
          return;
        }

        const {
          item
        } = data;
        this.$router.push(`/rekam-medis/${item.id}/${item.pasien_id}`);
      },
      toggleModal() {
        // We pass the ID of the button that we want to return focus to
        // when the modal has hidden
        this.$refs["my-modal"].toggle("#toggle-btn");
      },
      async getPasien(id) {
        if (!id) {
          return false;
        }
        try {
          const res = await this.$axios.get(`transaksi/${id}`);
          const {
            status,
            data,
            message
          } = res.data;
          if (status) {
            const {
              waktu_konsultasi,
              examination_by: dokter_id,
              anamnesa,
              pasien
            } = data;
            return {
              waktu_konsultasi,
              dokter_id,
              anamnesa,
              pasien
            };
          } else {
            this.$swal({
              text: message,
              type: "warning"
            });
          }
        } catch (err) {
          // alert(err);
        }
      },
      pembatalanAntrean({
        namaPasien = null,
        id
      } = {}) {
        this.$swal({
          title: startCase("pembatalan antrean"),
          text: `Apakah antrean pasien ${namaPasien} benar akan dibatalkan?`,
          type: "question",
          showCancelButton: true,
          cancelButtonText: startCase("tidak"),
          confirmButtonText: startCase("ya")
        }).then(res => {
          const {
            value
          } = res;
          if (value) {
            this.updateStatusAntrean("batal", id);
          }
        });
      },
      async updateStatusAntrean(antreanStatus, id) {
        try {
          const res = await this.$axios.put(`transaksi/${id}`, {
            status: antreanStatus.toUpperCase()
          });
          const {
            status,
            data,
            message
          } = res.data;
          if (status) {
            this.$swal({
              type: "success",
              title: startCase("sukses hapus antrean"),
              text: `Antrean pasien sudah dibatalkan.`,
            });
            this.fetchListAntrean();
          } else {
            this.$swal({
              text: message,
              type: "warning"
            });
          }
        } catch (err) {}
      },
      tanggalSelected($event) {
        this.tanggal = moment($event).format("YYYY-MM-DD");
      }
    }
  };
</script>